import styled from 'styled-components';
import { GraphControlsContainer } from '../Grid';
import { smallMediaQuery } from '../Grid';

export const Container = styled(GraphControlsContainer)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const svgWidth = 60;
export const svgHeight = 40;

export const SvgContainer = styled.div`
  margin-right: 20px;

  @media ${smallMediaQuery} {
    margin-right: 8px;
  }
`;
